import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
  getSelectedZusatzoptionen,
  GlobalActions,
  GlobalPut,
  PhCheckoutProduktPayload,
} from '@ps20-frontend/shop-integration-redux';
import { App, Produktlinie } from '@ps20-frontend/frontend-models';
import { getSelectedProduktlinie } from '@ps20-frontend/preis-lib';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { PhActions } from '../phActions';
import { IAppState } from '../appState';
import { selectAnzahlWohnungen } from '../../app/shared/selectors/anzahlWohnungen.selector';

export function* watchInDashboardUebernehmenSaga() {
  yield takeEvery(PhActions.ABSPRUNG_INS_DASHBOARD, safeSaga(generateDashboardData, App.PH));
  yield takeEvery(PhActions.ABSPRUNG_INS_DASHBOARD, safeSaga(generateProduktData, App.PH));
}

export function* generateProduktData() {
  const globalPut = GlobalPut.getInstance();
  const state: IAppState = yield select();
  const anzahlVersicherterWohnungen = selectAnzahlWohnungen(state);

  const produktData: PhCheckoutProduktPayload = {
    appId: App.PH,
    laufzeit: state.vertragsoptionen.vertragslaufzeit,
    uebersichtTitle: 'Haftpflichtversicherung',
    versichertesRisiko: `${state.risikoort.strasse} ${state.risikoort.hausnummer}, ${state.risikoort.plz} ${state.risikoort.ort}`,
    anzahlVersicherterWohnungen: anzahlVersicherterWohnungen,
    vorvertragsnummer: state.vertragsoptionen.vorvertragsNummern,
    vorvertragSofortschutz: state.vertragsoptionen.vorvertragSofortschutz,
    beginndatum: state.vertragsoptionen.beginnDatum,
    angebotsdatum: state.vertragsoptionen.angebotsdatum,
  };
  yield call([globalPut, globalPut.put], new GlobalActions().produktAction(produktData));
}

export function* generateDashboardData() {
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();
  const selectedProduktlinie: Produktlinie = getSelectedProduktlinie(state.produkt);

  yield put(new PhActions().vorschlagdatenChanged());

  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().inDashboardUebernehmen({
      appId: App.PH,
      kurztext: selectedProduktlinie.kurztext,
      ausgewaehlteLinie: selectedProduktlinie.produktName,
      versichertesRisiko: `${state.risikoort.strasse} ${state.risikoort.hausnummer}, ${state.risikoort.plz} ${state.risikoort.ort}`,
      vertragslaufzeit: state.vertragsoptionen.vertragslaufzeit,
      selectZusatzoptionen: getSelectedZusatzoptionen(selectedProduktlinie.zusatzoptionen),
      beginn: state.vertragsoptionen.beginnDatum,
    }),
  );
}
